// extracted by mini-css-extract-plugin
module.exports = {"leaveExamModal":"ModalAccessibility_leaveExamModal__3CYoE"};